import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

const PageNotFound = () => {
	return (
		<div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center px-3">
			<div className="highlight-title" data-aos="fade-up">
				<h1 className="display-4 fw-bold">404 Error - Page Not Found</h1>
				<p className="fs-5 mt-3">
					The page you are looking for could not be found. Please check the URL
					or go back to the homepage.
				</p>
				<Link to="/" className="btn btn-primary mt-3">
					Go back to Home
					<span className="ms-2">
						<FiArrowUpRight size={16} />
					</span>
				</Link>
			</div>
		</div>
	);
};

export default PageNotFound;
